import { FC, useMemo, ReactNode } from 'react';
import MoreMenu from '@/components/more-menu';
import { ConnectorModel } from '@/lib/models/connector/connector.model';
import { getTypedConnector } from '@/lib/models/connector';
import { ContextProviderType } from '@/lib/models/context-provider';
import { WebcrawlerConfig } from '@/lib/models/connector/webcrawler-connector.model';
import { SharepointConfig } from '@/lib/models/connector/sharepoint-connector.model';
import CopyMenuItem from '@/components/more-menu/copy-menu-item';
import { UpdateMenuItemProps } from '@/components/more-menu/helpers';
import UpdateMenuItems from '@/components/more-menu/update-menu-items';

interface Props extends UpdateMenuItemProps {
  connector: ConnectorModel | null;
  providerType: ContextProviderType | '';
}

const ContextProviderMenu: FC<Props> = ({ connector, providerType, showUpdateMenu, ...rest }) => {
  const menuItems = useMemo(() => {
    if (!connector || !providerType) {
      return [];
    }

    const items: ReactNode[] = [];
    const { config } = getTypedConnector(connector);

    // Webcrawler context provider menu items
    if (providerType === 'surepath-kendra-webcrawler') {
      const { url } = config as WebcrawlerConfig;
      items.push(
        <CopyMenuItem value={url} label="Copy Connector Base URL" icon="link" key="copy-base-url" />
      );
    }

    // SharePoint context provider menu items
    if (providerType === 'surepath-kendra-sharepoint') {
      const { sharepointSite } = config as SharepointConfig;
      items.push(
        <CopyMenuItem
          value={sharepointSite}
          label="Copy Connector Base URL"
          icon="link"
          key="copy-base-url"
        />
      );
    }

    if (showUpdateMenu) {
      items.push(<UpdateMenuItems key="update-menu-items" {...rest} />);
    }

    return items;
  }, [connector, providerType, showUpdateMenu, rest]);

  return <MoreMenu menuId="context-provider-menu">{menuItems}</MoreMenu>;
};

export default ContextProviderMenu;
